import { apiUrls } from '../../utils/api/api-urls';
import REQUEST from '../../utils/services';

const { advSales: { getAdvSales, } } = apiUrls;

export const ADV_SALES_SUCCESS = 'ADV_SALES_SUCCESS';
export const ADV_SALES_LOADING = 'ADV_SALES_LOADING';


export const getAdvSalesData = ({ fromdate, todate }) => async (dispatch) => {
        try {
            const { url } = getAdvSales
            const requestData = {
                ...getAdvSales,
                url: url.replace('{{fromdate}}', fromdate).replace('{{todate}}', todate)
            };
            const data = await REQUEST(requestData);
            dispatch({
                type: ADV_SALES_SUCCESS,
                data,
            })
        } catch (e) {

            dispatch({
                type: ADV_SALES_SUCCESS,
                data: {
                    code: "",
                    modal: null,
                    notifications: null,
                    paginationInfo: null
                }
            })
        }

    }



export const handleLoader = isLoading => (dispatch) => {
    dispatch({
        type: ADV_SALES_LOADING,
        isLoading
    })
}
